module.exports = __webpack_public_path__ + "img/icon-video-play.f73c4ffc.svg";